import {LOADED_AUTOCOMPLETE_ITEMS, LOADED_AUTOCOMPLETE_TOTALS} from "./autocomplete_actions";

const autocomplete_items = (payload = {}, action) => {
    switch (action.type) {
        case LOADED_AUTOCOMPLETE_ITEMS:
            const state = {...payload};
            state[action.id] = action.payload;

            return state;
        default:
            return payload;
    }
};
const autocomplete_totals = (payload = {}, action) => {
    switch (action.type) {
        case LOADED_AUTOCOMPLETE_TOTALS:
            const state = {...payload};
            state[action.id] = action.payload;

            return state;
        default:
            return payload;
    }
};

export default {
    autocomplete_items,
    autocomplete_totals
}
